import { render, staticRenderFns } from "./forgotPassword.vue?vue&type=template&id=938f338a&scoped=true"
import script from "./forgotPassword.vue?vue&type=script&lang=js"
export * from "./forgotPassword.vue?vue&type=script&lang=js"
import style0 from "./forgotPassword.vue?vue&type=style&index=0&id=938f338a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938f338a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('938f338a')) {
      api.createRecord('938f338a', component.options)
    } else {
      api.reload('938f338a', component.options)
    }
    module.hot.accept("./forgotPassword.vue?vue&type=template&id=938f338a&scoped=true", function () {
      api.rerender('938f338a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/login/forgotPassword.vue"
export default component.exports